import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b475851"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-x @todo" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = ["size"]
const _hoisted_5 = { class: "float-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status: ", -1))
const _hoisted_7 = ["value", "textContent"]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "flex mb-4" }
const _hoisted_10 = { class: "w-1/2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "mb-3",
  contenteditable: ""
}, "From:", -1))
const _hoisted_12 = { class: "div-address" }
const _hoisted_13 = ["cols", "rows"]
const _hoisted_14 = { class: "w-1/2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "mb-3",
  contenteditable: ""
}, "To:", -1))
const _hoisted_16 = { class: "div-address" }
const _hoisted_17 = ["cols", "rows"]
const _hoisted_18 = { class: "table-responsive-sm" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "print-hidden" }, null, -1))
const _hoisted_20 = { class: "table table-striped" }
const _hoisted_21 = ["contenteditable"]
const _hoisted_22 = ["textContent"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onUpdate:modelValue", "size"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = ["onUpdate:modelValue", "size"]
const _hoisted_28 = ["onUpdate:modelValue", "size"]
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = ["textContent"]
const _hoisted_31 = { class: "print-hidden" }
const _hoisted_32 = { colspan: "100%" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "w-1/2 ml-auto" }
const _hoisted_35 = { class: "table table-clear" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("strong", { contenteditable: "" }, "Subtotal")
], -1))
const _hoisted_37 = ["textContent"]
const _hoisted_38 = { class: "left" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { contenteditable: "" }, "Discount ", -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_41 = ["textContent"]
const _hoisted_42 = { class: "left" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { contenteditable: "" }, "VAT ", -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_45 = ["textContent"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("strong", { contenteditable: "" }, "Total")
], -1))
const _hoisted_47 = { class: "text-right" }
const _hoisted_48 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoiceData.name) = $event)),
          class: "invoice-name mr-2",
          size: _ctx.getInputElSize(_ctx.invoiceData.name)
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.invoiceData.name]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "invoice-date",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invoiceData.date) = $event))
        }, null, 512), [
          [_vModelText, _ctx.invoiceData.date]
        ]),
        _createElementVNode("span", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            name: "invoice-status",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.invoiceData.status) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceOptions.status, (status) => {
              return (_openBlock(), _createElementBlock("option", {
                key: status.value ?? status,
                value: status.value ?? status,
                textContent: _toDisplayString(status.name ?? status)
              }, null, 8, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.invoiceData.status]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input-name company-name",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyInfo.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.companyInfo.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("textarea", {
                class: "input-address",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyInfo.address) = $event)),
                cols: _ctx.invoiceOptions.addressTextArea.cols,
                rows: _ctx.invoiceOptions.addressTextArea.rows,
                onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.adjustTextAreaHeight && _ctx.adjustTextAreaHeight(...args)))
              }, null, 40, _hoisted_13), [
                [_vModelText, _ctx.companyInfo.address]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input-name customer-name",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customerInfo.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.customerInfo.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("textarea", {
                class: "input-address",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customerInfo.address) = $event)),
                cols: _ctx.invoiceOptions.addressTextArea.cols,
                rows: _ctx.invoiceOptions.addressTextArea.rows,
                onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.adjustTextAreaHeight && _ctx.adjustTextAreaHeight(...args)))
              }, null, 40, _hoisted_17), [
                [_vModelText, _ctx.customerInfo.address]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceHeaders, (header, headerKey) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: headerKey,
                    contenteditable: header.editable,
                    class: _normalizeClass([header.class, header.hidden ? `print-hidden` : null])
                  }, [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(header.title)
                    }, null, 8, _hoisted_22),
                    (header.canHide)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "ml-2 print-hidden cursor-help",
                          type: "checkbox",
                          title: "Hide on print?",
                          "onUpdate:modelValue": ($event: any) => ((header.hidden) = $event)
                        }, null, 8, _hoisted_23)), [
                          [_vModelCheckbox, header.hidden]
                        ])
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_21))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceItems, (item, k) => {
                return (_openBlock(), _createElementBlock("tr", { key: k }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(["center", _ctx.isHiddenField(`sno`)])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.sno) = $event),
                      size: _ctx.getInputElSize(item.sno)
                    }, null, 8, _hoisted_24), [
                      [_vModelText, item.sno]
                    ])
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["left strong", _ctx.isHiddenField(`name`)])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                    }, null, 8, _hoisted_25), [
                      [_vModelText, item.name]
                    ])
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["left", _ctx.isHiddenField(`description`)])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.description) = $event)
                    }, null, 8, _hoisted_26), [
                      [_vModelText, item.description]
                    ])
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-right", _ctx.isHiddenField(`unitCost`)])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((item.unitCost) = $event),
                      size: _ctx.getInputElSize(item.unitCost)
                    }, null, 8, _hoisted_27), [
                      [_vModelText, item.unitCost]
                    ])
                  ], 2),
                  _createElementVNode("td", {
                    class: _normalizeClass(["center", _ctx.isHiddenField(`quantity`)])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                      max: 100,
                      size: _ctx.getInputElSize(item.quantity)
                    }, null, 8, _hoisted_28), [
                      [_vModelText, item.quantity]
                    ])
                  ], 2),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_ctx.getItemTotal(item.quantity, item.unitCost))
                    }, null, 8, _hoisted_30)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", _hoisted_31, [
                _createElementVNode("td", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "btn btn-primary add-more",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addNewItem && _ctx.addNewItem(...args)))
                  }, " + Add More ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_36,
                  _createElementVNode("td", {
                    class: "text-right",
                    textContent: _toDisplayString(_ctx.getCurrencyFormat(_ctx.subTotal))
                  }, null, 8, _hoisted_37)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_38, [
                    _createElementVNode("strong", null, [
                      _hoisted_39,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "input-percentage",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.discountRate) = $event)),
                        min: 0,
                        max: 100
                      }, null, 512), [
                        [_vModelText, _ctx.discountRate]
                      ]),
                      _hoisted_40
                    ])
                  ]),
                  _createElementVNode("td", {
                    class: "text-right",
                    textContent: _toDisplayString(_ctx.getCurrencyFormat(_ctx.discountAmount))
                  }, null, 8, _hoisted_41)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_42, [
                    _createElementVNode("strong", null, [
                      _hoisted_43,
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "input-percentage",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.invoiceTax) = $event)),
                        min: 0,
                        max: 100
                      }, null, 512), [
                        [_vModelText, _ctx.invoiceTax]
                      ]),
                      _hoisted_44
                    ])
                  ]),
                  _createElementVNode("td", {
                    class: "text-right",
                    textContent: _toDisplayString(_ctx.getCurrencyFormat(_ctx.taxAmount))
                  }, null, 8, _hoisted_45)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_46,
                  _createElementVNode("td", _hoisted_47, [
                    _createElementVNode("strong", {
                      textContent: _toDisplayString(_ctx.getCurrencyFormat(_ctx.grandTotal))
                    }, null, 8, _hoisted_48)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}